import { defaultFormatter, onHoverPopUpTooltipFormatter } from "pages/Admin/Users/UserComponents/UserList/Formatters";
import { LEAD_TYPE_IDS } from "./sf_constants";
import { forColumnHeaderWrapper, nullHandlerCustomizeColumns } from "./sf_utils";
export const wordBreakWithSpace = (str) => {
  if (str === null || str === undefined || str === '') return '';
  // remove leading/trailing spaces
  str = String(str).trim();
  // break word where capital letters start
  str = str.replace(/([a-z])([A-Z])/g, '$1 $2');

  return str;
}

export const isAutoOrMotorcycle = (leadTypeId) => {
  const { AUTO, MOTORCYCLE } = LEAD_TYPE_IDS;
  return [AUTO, MOTORCYCLE].includes(leadTypeId);
};

//SIC and NAICS columns for commerical leads
const columnConfigMap = {
  sic4: {
    text: 'SIC',
    formatter: 'defaultFormatter',
  },
  naics: {
    text: 'NAICS',
    formatter: 'defaultFormatter',
  },
  business_name: {
    text: 'Business Name',
    formatter: 'defaultFormatter',
  },
  business_desc: {
    text: 'Business Description',
    formatter: 'tooltipFormatter',
    style: { maxWidth: '250px', textOverflow: 'ellipsis', overflow: 'hidden' },
  },
};

export const generateSICColumns = (productType, hideUserColumnPreference, columns = columnConfigMap) => {
  const formatters = {
    defaultFormatter,
    tooltipFormatter: (cellContent, row, rowIndex) =>
      onHoverPopUpTooltipFormatter(cellContent, row, rowIndex, 'business_desc'),
  };

  return Object.entries(columns).map(([key, config]) => ({
    dataField: `lead_business_entities[0].${key}`,
    text: config.text,
    sort: true,
    hidden: nullHandlerCustomizeColumns(hideUserColumnPreference?.[`${productType}_${key}`]),
    headerFormatter: forColumnHeaderWrapper,
    formatter: formatters[config.formatter],
    csvFormatter: (cellContent) => cellContent || '--',
    columnName: `${productType}_${key}`,
    ...(config.style ? { style: config.style } : {}),
  }));
};

